const enviroment = {
    apiURL: 'https://foyjq6esp9.execute-api.us-east-1.amazonaws.com/api',
    // apiURL: 'https://t4mpwztuh5.execute-api.us-east-1.amazonaws.com/api',
    // apiURL: 'https://m2czwafhja.execute-api.us-east-1.amazonaws.com/api',
    storageURL: 'https://postula.empresasquetransforman.pe/public/',
    reCaptcha: '6LeF8igbAAAAAPxfvjHYnNdeFeAeuQ16_oic2BEU',
    limitApply: 100,
    limitUpload: {
        video: 500 * 1024 * 1024,
        videoTime: '90 segundos',
        videoWeight: '500 megas',
        videoAllow:
            '.video/mp4, video/quicktime, video/avi, video/mov, video/mpeg',
        videoAllowFormats: 'mpeg, mp4, mov, avi.',
        videoErrorWeight: 'El peso del video no debe ser mayor a 500 megas',
        videoErrorFormat:
            'El formato del video debe ser: .mpeg, .mp4, .mov, .avi.',
        doc: 10 * 1024 * 1024,
        docAllow: 'word, .doc, .docx, .pdf, zip',
        docErrorWeight:
            'El peso del documento o archivo no debe ser mayor a 10 megas.',
        docErrorFormat:
            'El formato del documento o archivo debe ser: Solo se .pdf, .doc, .docx y .zip',
        errorGeneric: 'Vuelve a intentarlo. Ocurrio un error inesperado.',
        successVideo: 'Su video fue cargado correctamente.',
        successDoc: 'Su documento fue cargado correctamente.',
    },
    awsAmplify: {
        Auth: {
            identityPoolId: 'us-east-1:a9939a5d-945b-4900-935c-87a9461189fd',
            region: 'us-east-1',
        },
        Storage: {
            AWSS3: {
                bucket: 'empresasquetransforman.com',
                region: 'us-east-1',
            },
        },
    },
    search: {
        limitPerPage: 20,
        formatDate: 'DD/MM/YYYY',
    },
};

export default enviroment;
